import * as React from "react";
import { HomeHeaderMenuConstants } from "../../models/constants/home-header-menu.constants";
import { IHomeHeaderMenu } from "../../models/interfaces/home-header-menu.interface";
import HomeHeaderMenu from "../../presentations/HomeHeaderMenu";

const HomeHeaderMenuContainer = () => {
  return (
    <div className="flex">
      {HomeHeaderMenuConstants.Menu.map((menu: IHomeHeaderMenu, index: number) => (
        <HomeHeaderMenu key={index} menu={menu}></HomeHeaderMenu>
      ))}
    </div>
  );
};

export default HomeHeaderMenuContainer;
